'use client'

import { IconButton, Tooltip } from '@mui/material'
import { IUploadedMedia } from '../hooks/use-media-upload'
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined'
import VideoCameraBackOutlinedIcon from '@mui/icons-material/VideoCameraBackOutlined'
interface IUploadButtonProps {
  uploadedMedia: IUploadedMedia[]
  maxImages: number
  maxVideos: number
  onUploadClick: (type: 'image' | 'video') => void
  disabled?: boolean
}

export const UploadButton = ({
  uploadedMedia,
  maxImages,
  maxVideos,
  onUploadClick,
  disabled = false,
}: IUploadButtonProps) => {
  const currentImages = uploadedMedia.filter((m) => m.type === 'image').length
  const currentVideos = uploadedMedia.filter((m) => m.type === 'video').length

  const canUploadImage = currentImages < maxImages
  const canUploadVideo = currentVideos < maxVideos

  return (
    <>
      <Tooltip title={canUploadImage ? `Tải ảnh (${currentImages}/${maxImages})` : 'Đã đạt giới hạn ảnh'}>
        <span>
          <IconButton
            size="small"
            onClick={() => onUploadClick('image')}
            disabled={disabled || !canUploadImage}
            sx={{
              color: canUploadImage ? 'text.primary' : 'text.disabled',
            }}
          >
            <ImageOutlinedIcon sx={{ fontSize: '24px' }} />
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title={canUploadVideo ? `Tải video (${currentVideos}/${maxVideos})` : 'Đã đạt giới hạn video'}>
        <span>
          <IconButton
            size="small"
            onClick={() => onUploadClick('video')}
            disabled={disabled || !canUploadVideo}
            sx={{
              color: canUploadVideo ? 'text.primary' : 'text.disabled',
            }}
          >
            <VideoCameraBackOutlinedIcon sx={{ fontSize: '24px' }} />
          </IconButton>
        </span>
      </Tooltip>
    </>
  )
}
